import { useTranslation } from "react-i18next";
import "./AgentAgencySwitch.css";

interface AgentAgencySwitchProps {
  isAgent: boolean;
  onToggle: (isAgent: boolean) => void;
}

const AgentAgencySwitch: React.FunctionComponent<AgentAgencySwitchProps> = ({
  isAgent,
  onToggle,
}) => {
  const { t } = useTranslation();

  const handleToggle = () => {
    onToggle(!isAgent);
  };

  return (
    <div className="agent-agency-switch-container">
      <div className="container">
        <div className="d-flex justify-content-center align-items-center">
          <div className="switch-wrapper">
            <button
              onClick={handleToggle}
              className={`switch-option ${isAgent ? "active" : ""}`}
            >
              {t("Agent")}
            </button>
            <button
              onClick={handleToggle}
              className={`switch-option ${!isAgent ? "active" : ""}`}
            >
              {t("Agencies")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AgentAgencySwitch;
